import { BreadcrumbHelper } from 'src/app/shared/helpers/breadcrumb.helper';
import { CustomRoute, ReuseStrategyType } from 'src/app/core/interfaces/custom-route.interface';
import { Route } from '@angular/router';
import { pageResolver } from '@scalefast/ecommerce-core';

type Breadcrumb = {
  page: Route;
};

export const PageComponentRoutes: CustomRoute[] = [
  {
    path: ':categorySlug1',
    loadComponent: () => import('./page.component').then((m) => m.AppPageComponent),
    data: {
      breadcrumb: (breadcrumb: Breadcrumb) => {
        return BreadcrumbHelper.getNameFromRoute(breadcrumb);
      },
    },
    resolve: { page: pageResolver },
    shouldReuse: ReuseStrategyType.never,
  },
  {
    path: ':categorySlug1/:categorySlug2',
    loadComponent: () => import('./page.component').then((m) => m.AppPageComponent),
    data: {
      breadcrumb: (breadcrumb: Breadcrumb) => {
        return BreadcrumbHelper.getNameFromRoute(breadcrumb);
      },
    },
    resolve: { page: pageResolver },
    shouldReuse: ReuseStrategyType.never,
  },
  {
    path: ':categorySlug1/:categorySlug2/:categorySlug3',
    loadComponent: () => import('./page.component').then((m) => m.AppPageComponent),
    data: {
      breadcrumb: (breadcrumb: Breadcrumb) => {
        return BreadcrumbHelper.getNameFromRoute(breadcrumb);
      },
    },
    resolve: { page: pageResolver },
    shouldReuse: ReuseStrategyType.never,
  },
  {
    path: ':pageSlug1/:pageSlug2/:pageSlug3/:pageSlug4',
    loadComponent: () => import('./page.component').then((m) => m.AppPageComponent),
    data: {
      breadcrumb: (breadcrumb: Breadcrumb) => {
        return BreadcrumbHelper.getNameFromRoute(breadcrumb);
      },
    },
    resolve: { page: pageResolver },
    shouldReuse: ReuseStrategyType.never,
  },
  {
    path: ':pageSlug1/:pageSlug2/:pageSlug3/:pageSlug4/:pageSlug5',
    loadComponent: () => import('./page.component').then((m) => m.AppPageComponent),
    data: {
      breadcrumb: (breadcrumb: Breadcrumb) => {
        return BreadcrumbHelper.getNameFromRoute(breadcrumb);
      },
    },
    resolve: { page: pageResolver },
    shouldReuse: ReuseStrategyType.never,
  },
];
